import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps } from './models';
import { DataLayer as Component } from './data-layer';

export const DataLayer = createWidget<unknown, IProps>()(Component);
